import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Switch,
  FormControl,
  FormLabel,
} from '@chakra-ui/react'
const SettingsModal = ({
  show,
  onClose,
  teraceEnabled,
  onTeraceChange,
  roomEnabled,
  onRoomChange,
  lobbyEnabled,
  onLobbyChange,
  showCompletedOrders,
  onShowCompletedOrdersChange,
}: any) => {
  return (
    <Modal isOpen={show} onClose={onClose}>
      <ModalOverlay />
      <ModalContent pb={4}>
        <ModalHeader>Settings</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack alignItems='flex-start' spacing={4}>
            <FormControl display='flex' alignItems='center' justifyContent='space-between'>
              <FormLabel htmlFor='terace-location' mb='0'>
                Enable Terace location
              </FormLabel>
              <Switch
                id='terace-location'
                size='lg'
                colorScheme='green'
                isChecked={teraceEnabled}
                onChange={onTeraceChange}
              />
            </FormControl>
            <FormControl display='flex' alignItems='center' justifyContent='space-between'>
              <FormLabel htmlFor='lobby-location' mb='0'>
                Enable Lobby location
              </FormLabel>
              <Switch
                id='lobby-location'
                size='lg'
                colorScheme='green'
                isChecked={lobbyEnabled}
                onChange={onLobbyChange}
              />
            </FormControl>
            <FormControl display='flex' alignItems='center' justifyContent='space-between'>
              <FormLabel htmlFor='room-location' mb='0'>
                Enable Room location
              </FormLabel>
              <Switch
                id='room-location'
                size='lg'
                colorScheme='green'
                isChecked={roomEnabled}
                onChange={onRoomChange}
              />
            </FormControl>
            <FormControl display='flex' alignItems='center' justifyContent='space-between'>
              <FormLabel htmlFor='show-completed-orders' mb='0'>
                Show completed orders
              </FormLabel>
              <Switch
                id='show-completed-orders'
                size='lg'
                colorScheme='green'
                isChecked={showCompletedOrders}
                onChange={onShowCompletedOrdersChange}
              />
            </FormControl>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default SettingsModal
